import React from 'react';
import { TextOverflow } from '@common/components/text-overflow';
import { CommentInfoFragmentType } from '@common/graphql';

export const CommentInline = ({
  comment,
  prefix,
}: {
  prefix?: string;
  comment: CommentInfoFragmentType;
}) => {
  return (
    <>
      <TextOverflow>
        <span className="comment-subtext">{`${prefix}"${comment.contentAsText}"`}</span>
      </TextOverflow>
      <style jsx>{`
        :global(.comment-subtext) {
          display: block;
          font-size: 16px;
          font-weight: 300;
        }
      `}</style>
    </>
  );
};
